
export async function get_setting_value(name)
{
	if (Grape.currentSession)
	{
		try
		{
			let result = await Grape.fetches.getJSON(`/api/setting/${name}`, {});

			if (result.status === 'ERROR')
			{
				console.error(`get grape setting "${name}" failed`);
				return result;
			}
			else return result.value;
		}
		catch (errorThrown)
		{
			console.error(`get grape setting "${name}" failed`);
			throw errorThrown;
		}
	}
}

export async function wizard() {
	return await get_setting_value('system.wizard') === 'true';
}

export async function wizard_all_tasks_done() {
	return await get_setting_value('system.wizard_all_tasks_done') === 'true';
}
